import { RenderingProps } from 'src/shared/shared.types';
import { BiographyDirectoryFields } from '../C55BiographyDirectory/C55BiographyDirectory.types';

export type C56BiographyGridProps = RenderingProps<BiographyDirectoryFields, BiographyGridParams>;

type BiographyGridParams = {
  GridNumberOfColumns?: string;
  HeadlineTag?: string;
};
